import {Button, Empty, Spin, Tag, Timeline, Typography} from "antd";
import {HistoryOutlined, RollbackOutlined} from "@ant-design/icons";
import dayjs from "dayjs";

import usePromptHistory from "../hooks/usePromptHistory.js";
import "./PromptHistoryTimeline.css";

const {Paragraph, Text} = Typography;

export default function PromptHistoryTimeline({entityType, entityId, onRestore, currentContent})
{
	const {history, total, loading, loadHistory} = usePromptHistory(entityType, entityId);

	if (loading && !history.length)
		return <Spin style={{display: "block", textAlign: "center", padding: 24}}/>;

	if (!history.length)
		return <Empty description="Nessuno storico disponibile" image={Empty.PRESENTED_IMAGE_SIMPLE}/>;

	const latestIsActive = currentContent == null || currentContent === history[0]?.content;

	return (
		<div className="prompt-history-timeline">
			<Timeline
				items={history.map((entry, index) =>
				{
					const isCurrent = index === 0 && latestIsActive;
					const showRestore = onRestore && !isCurrent;

					return {
						dot: index === 0
							? <HistoryOutlined style={{fontSize: 16}}/>
							: undefined,
						children: (
							<div className="prompt-history-card">
								<div className="prompt-history-card-header">
									<Text strong>v{entry.version}</Text>
									{isCurrent && <Tag color="green">Corrente</Tag>}
									<Text type="secondary" style={{fontSize: 12}}>
										{dayjs(entry.createdAt).format("DD/MM/YYYY HH:mm")}
									</Text>
								</div>
								<Paragraph
									className="prompt-history-card-content"
									ellipsis={{rows: 3, expandable: true, symbol: "mostra tutto"}}
									style={{marginBottom: 8}}
								>
									{entry.content}
								</Paragraph>
								{showRestore && (
									<Button
										size="small"
										icon={<RollbackOutlined/>}
										onClick={() => onRestore(entry.content)}
									>
										Ripristina
									</Button>
								)}
							</div>
						)
					};
				})}
			/>
			{history.length < total && (
				<Button
					type="link"
					loading={loading}
					onClick={() => loadHistory(20, history.length)}
					style={{display: "block", margin: "0 auto"}}
				>
					Carica altre versioni
				</Button>
			)}
		</div>
	);
}
